import { RouteInfo } from "./sidebar.metadata";

export const AdminModule: RouteInfo[] = [
  //************************************************************************************************************************* */
  //ADMIN MODULE
  //************************************************************************************************************************* */
  {
    path: "",
    title: "MENUITEMS.MAIN.TEXT",
    moduleName: "",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },

  {
    path: "/erp-admin/dashboard",
    title: "Dashboard",
    moduleName: "dashboard",
    iconType: "feather",
    icon: "monitor",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },

  // {
  //   path: "",
  //   title: "Parameters",
  //   moduleName: "",
  //   iconType: "",
  //   icon: "",
  //   class: "",
  //   groupTitle: true,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["All"],
  //   privilege: ["All Departements", "Manage Department"],
  //   submenu: [],
  // },

  // {
  //   path: "",
  //   title: "Departments",
  //   moduleName: "departments",
  //   iconType: "feather",
  //   icon: "grid",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: [""],
  //   privilege: ["All Departments", "Manage Department"],
  //   submenu: [
  //     {
  //       path: "/erp-admin/admin-parameters/all-departments",
  //       title: "All Departments",
  //       moduleName: "departments",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["All Departments"],
  //       submenu: [],
  //     },
  //     {
  //       path: "/erp-admin/admin-parameters/manage-departments",
  //       title: "Manage Departemnt",
  //       moduleName: "departments",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["Manage Department"],
  //       submenu: [],
  //     },
  //   ],
  // },

  {
    path: "",
    title: "Admin Sub-Modules",
    moduleName: "",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },

  {
    path: "/erp-admin/admin/email-configuration",
    title: "Email Configuration",
    moduleName: "email-configuration",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },
  {
    path: "/erp-admin/admin/all-privileges",
    title: "Privileges",
    moduleName: "Privileges",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },
  {
    path: "/erp-admin/admin/all-delegations",
    title: "Role Delegation",
    moduleName: "Privileges",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All Privilege Delegations", "Dashboard"],
    submenu: [],
  },

  {
    path: "",
    title: "Roles",
    moduleName: "admins",
    iconType: "feather",
    icon: "grid",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All Roles", "Manage Role"],
    submenu: [
      {
        path: "/erp-admin/admin/all-roles",
        title: "All Roles",
        moduleName: "admin",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All Roles"],
        submenu: [],
      },
      {
        path: "/erp-admin/admin/manage-role",
        title: "Manage Role",
        moduleName: "admin",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Manage Role"],
        submenu: [],
      },
    ],
  },

  {
    path: "",
    title: "Audit",
    moduleName: "audit",
    iconType: "feather",
    icon: "grid",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All Roles", "Manage Role"],
    submenu: [
      {
        path: "/erp-admin/admin/audit-trails",
        title: "Audit Trails",
        moduleName: "audit",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All Roles"],
        submenu: [],
      }
    ],
  },

  // "All Requests",
  // "Manage Request",

  // {
  //   path: "",
  //   title: "Initiate Requests",
  //   moduleName: "admin",
  //   iconType: "feather",
  //   icon: "grid",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: [""],
  //   privilege: ["All Requests", "Manage Request"],

  //   submenu: [
  //     {
  //       path: "/erp-admin/admin/all-requests",
  //       title: "All Requests",
  //       moduleName: "admin",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["All Requests"],
  //       submenu: [],
  //     },
  //     {
  //       path: "/erp-admin/admin/manage-request",
  //       title: "Manage Request",
  //       moduleName: "admin",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["Manage Request"],
  //       submenu: [],
  //     },
  //   ],
  // },

  // {
  //   path: "/erp-admin/admin/access-request",
  //   title: "Access Request",
  //   moduleName: "admin",
  //   iconType: "feather",
  //   icon: "grid",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["All"],
  //   privilege: ["Access Request"],
  //   submenu: [],
  // },

  {
    path: "/erp-admin/admin/all-users",
    title: "User Management",
    moduleName: "user-management",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Login session"],
    submenu: [],
  },

  {
    path: "/erp-admin/admin/login-session",
    title: "Login session",
    moduleName: "admin",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Login session"],
    submenu: [],
  },
  {
    path: "/erp-admin/admin/application-logs",
    title: "Application Logs",
    moduleName: "admin",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Application Logs"],
    submenu: [],
  },
];

export const HumanResourceModule: RouteInfo[] = [
  {
    path: "",
    title: "MENUITEMS.MAIN.TEXT",
    moduleName: "",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },
  {
    path: "/erp-hr/dashboard",
    title: "Dashboard",
    moduleName: "dashboard",
    iconType: "feather",
    icon: "monitor",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },

  {
    path: "/erp-hr/configurations/",
    title: "Configurations",
    moduleName: "configurations",
    iconType: "feather",
    icon: "grid",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: [
      "View Configuration",
      "Maintain Configuration",
      "Approve Configuration",
    ],
    submenu: [
      {
        path: "/erp-hr/configurations/organization-details",
        title: "Organization",
        moduleName: "configurations",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Configuration",
          "Maintain Configuration",
          "Approve Configuration",
        ],
        submenu: [],
      },
      {
        path: "/erp-hr/configurations/organization-structure",
        title: "Organization Structure",
        moduleName: "configurations",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Configuration",
          "Maintain Configuration",
          "Approve Configuration",
        ],
        submenu: [],
      },

      {
        path: "/erp-hr/configurations/branches",
        title: "Branches",
        moduleName: "configurations",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Configuration",
          "Maintain Configuration",
          "Approve Configuration",
        ],
        submenu: [],
      },
      {
        path: "/erp-hr/configurations/departments",
        title: "Departments",
        moduleName: "configurations",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Configuration",
          "Maintain Configuration",
          "Approve Configuration",
        ],
        submenu: [],
      },
      {
        path: "/erp-hr/configurations/job-grades",
        title: "Job Grades",
        moduleName: "configurations",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Configuration",
          "Maintain Configuration",
          "Approve Configuration",
        ],
        submenu: [],
      },
      {
        path: "/erp-hr/configurations/job-roles",
        title: "Job Role",
        moduleName: "configurations",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Configuration",
          "Maintain Configuration",
          "Approve Configuration",
        ],
        submenu: [],
      },
      {
        path: "/erp-hr/configurations/leave-bands",
        title: "Annual Leave Bands",
        moduleName: "configurations",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Configuration",
          "Maintain Configuration",
          "Approve Configuration",
        ],
        submenu: [],
      },
      {
        path: "/erp-hr/configurations/holidays",
        title: "Holiday",
        moduleName: "configurations",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Configuration",
          "Maintain Configuration",
          "Approve Configuration",
        ],
        submenu: [],
      },
      {
        path: "/erp-hr/configurations/leave-types",
        title: "Leave Types",
        moduleName: "configurations",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Configuration",
          "Maintain Configuration",
          "Approve Configuration",
        ],
        submenu: [],
      },
      {
        path: "/erp-hr/configurations/kpi-schedule",
        title: "KPI Schedules",
        moduleName: "configurations",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Configuration",
          "Maintain Configuration",
          "Approve Configuration",
        ],
        submenu: [],
      },
      {
        path: "/erp-hr/configurations/kpi-analysis",
        title: "KPI Analysis",
        moduleName: "configurations",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Configuration",
          "Maintain Configuration",
          "Approve Configuration",
        ],
        submenu: [],
      },
      {
        path: "/erp-hr/configurations/allowance-types",
        title: "Allowance Types",
        moduleName: "configurations",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Configuration",
          "Maintain Configuration",
          "Approve Configuration",
        ],
        submenu: [],
      },
      {
        path: "/erp-hr/configurations/deduction-types",
        title: "Deduction Types",
        moduleName: "configurations",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Configuration",
          "Maintain Configuration",
          "Approve Configuration",
        ],
        submenu: [],
      },
    ],
  },

  {
    path: "",
    title: "Statutory Deductions",
    moduleName: "deductions",
    iconType: "feather",
    icon: "grid",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: [
      "View Statutory Deductions",
      "Maintain Statutory Deductions",
      "Approve Statutory Deductions",
    ],
    submenu: [
      // {
      //   path: "/erp-hr/deductions/nhif",
      //   title: "NHIF",
      //   moduleName: "deductions",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   role: [""],
      //   privilege: [
      //     "View Statutory Deductions",
      //     "Maintain Statutory Deductions",
      //     "Approve Statutory Deductions",
      //   ],
      //   submenu: [],
      // },
      {
        path: "/erp-hr/deductions/shif",
        title: "SHIF",
        moduleName: "deductions",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Statutory Deductions",
          "Maintain Statutory Deductions",
          "Approve Statutory Deductions",
        ],
        submenu: [],
      },
      // {
      //   path: "/erp-hr/deductions/staff-welfare",
      //   title: "STAFF WELFARE",
      //   moduleName: "deductions",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   role: [""],
      //   privilege: [
      //     "View Statutory Deductions",
      //     "Maintain Statutory Deductions",
      //     "Approve Statutory Deductions",
      //   ],
      //   submenu: [],
      // },
      // {
      //   path: "/erp-hr/deductions/bifu",
      //   title: "BIFU",
      //   moduleName: "deductions",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   role: [""],
      //   privilege: [
      //     "View Statutory Deductions",
      //     "Maintain Statutory Deductions",
      //     "Approve Statutory Deductions",
      //   ],
      //   submenu: [],
      // },
      {
        path: "/erp-hr/deductions/nssf",
        title: "NSSF",
        moduleName: "deductions",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Statutory Deductions",
          "Maintain Statutory Deductions",
          "Approve Statutory Deductions",
        ],
        submenu: [],
      },
      {
        path: "/erp-hr/deductions/paye",
        title: "PAYE",
        moduleName: "deductions",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Statutory Deductions",
          "Maintain Statutory Deductions",
          "Approve Statutory Deductions",
        ],
        submenu: [],
      },
      {
        path: "/erp-hr/deductions/fringe-benefit",
        title: "FRINGE BENEFIT",
        moduleName: "deductions",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Statutory Deductions",
          "Maintain Statutory Deductions",
          "Approve Statutory Deductions",
        ],
        submenu: [],
      },
      {
        path: "/erp-hr/deductions/paye-relief",
        title: "PAYE RELIEF",
        moduleName: "deductions",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Statutory Deductions",
          "Maintain Statutory Deductions",
          "Approve Statutory Deductions",
        ],
        submenu: [],
      },
      {
        path: "/erp-hr/deductions/house-levy",
        title: "HOUSE LEVY",
        moduleName: "deductions",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Statutory Deductions",
          "Maintain Statutory Deductions",
          "Approve Statutory Deductions",
        ],
        submenu: [],
      },
    ],
  },

  {
    path: "",
    title: "Job Management",
    moduleName: "jobs",
    iconType: "feather",
    icon: "grid",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: [
      "View Job Management",
      "Maintain Job Management",
      "Approve Job Management",
    ],
    submenu: [
      {
        path: "/erp-hr/jobs/all-jobs",
        title: "All Jobs",
        moduleName: "jobs",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Job Management",
          "Maintain Job Management",
          "Approve Job Management",
        ],
        submenu: [],
      },
      {
        path: "/erp-hr/jobs/all-job-applications",
        title: "Job Applications",
        moduleName: "jobs",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Job Management",
          "Maintain Job Management",
          "Approve Job Management",
        ],
        submenu: [],
      },
      {
        path: "/erp-hr/jobs/interviews-management",
        title: "Interview Management",
        moduleName: "jobs",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Job Management",
          "Maintain Job Management",
          "Approve Job Management",
        ],
        submenu: [],
      },
      {
        path: "/erp-hr/jobs/all-interviews",
        title: "All Interviews",
        moduleName: "jobs",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Job Management",
          "Maintain Job Management",
          "Approve Job Management",
        ],
        submenu: [],
      },
    ],
  },

  {
    path: "",
    title: "Employee Management",
    moduleName: "employees",
    iconType: "feather",
    icon: "grid",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: [
      "View Employee Management",
      "Maintain Employee Management",
      "Approve Employee Management",
    ],
    submenu: [
      {
        path: "/erp-hr/employees/all-employees",
        title: "All Employees",
        moduleName: "employees",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Employee Management",
          "Maintain Employee Management",
          "Approve Employee Management",
        ],
        submenu: [],
      },
      {
        path: "/erp-hr/employees/manage-employees",
        title: "Manage Employees",
        moduleName: "employees",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Employee Management",
          "Maintain Employee Management",
          "Approve Employee Management",
        ],
        submenu: [],
      },
      {
        path: "/erp-hr/employees/all-employee-documents",
        title: "Employee Documents",
        moduleName: "employees",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Employee Management",
          "Maintain Employee Management",
          "Approve Employee Management",
        ],
        submenu: [],
      },
    ],
  },

  {
    path: "/erp-hr/employee-activities/all-employee-promotions",
    title: "Employee Promotions",
    moduleName: "promotions",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: [
      "View Employee Promotion",
      "Maintain Employee Promotion",
      "Approve Employee Promotion",
    ],
    submenu: [],
  },

  {
    path: "/erp-hr/employee-activities/all-employee-demotions",
    title: "Employee Demotions",
    moduleName: "demotions",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: [
      "View Employee Demotion",
      "Maintain Employee Demotion",
      "Approve Employee Demotion",
    ],
    submenu: [],
  },


  {
    path: "/erp-hr/employee-activities/all-employee-transfers",
    title: "Employee Transfer",
    moduleName: "transfers",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: [
      "View Employee Transfer",
      "Maintain Employee Transfer",
      "Approve Employee Transfer",
    ],
    submenu: [],
  },

  {
    path: "/erp-hr/employee-activities/all-employee-job-role-transfer",
    title: "Employee Job Role Transfer",
    moduleName: "employee-job-role-transfer",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: [
      "View Employee Job Role Transfer",
      "Maintain Employee Job Role Transfer",
      "Approve Employee Job Role Transfer",
    ],
    submenu: [],
  },

  // {
  //   path: "/erp-hr/employee-activities/all-employee-job-role-transfer",
  //   title: "Employee Job Role Transfer",
  //   moduleName: "employee-job-role-transfer",
  //   iconType: "feather",
  //   icon: "grid",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: [""],
  //   privilege: [
  // "View Employee Job Role Transfer",
  // "Maintain Employee Job Role Transfer",
  // "Approve Employee Job Role Transfer",
  //   ],
  //   submenu: [],
  // },

  {
    path: "",
    title: "Pension Scheme",
    moduleName: "pension",
    iconType: "feather",
    icon: "grid",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: [
      "View Employee Pension",
      "Maintain Employee Pension",
      "Approve Employee Pension",
    ],
    submenu: [
      {
        path: "/erp-hr/pension/all-pension-enrolment",
        title: "Pension Enrollment",
        moduleName: "pension",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Employee Pension",
          "Maintain Employee Pension",
          "Approve Employee Pension",
        ],
        submenu: [],
      },
      {
        path: "/erp-hr/pension/all-pension-contributions",
        title: "Pension Contributions",
        moduleName: "pension",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Employee Pension",
          "Maintain Employee Pension",
          "Approve Employee Pension",
        ],
        submenu: [],
      },
    ],
  },

  {
    path: "",
    title: "Payroll Management",
    moduleName: "payroll",
    iconType: "feather",
    icon: "grid",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: [
      "View Employee Payroll",
      "Download Payslips and P9",

      "Open Payslips",

      "Open and Close Payroll",
      "Process Employee Payroll",
      "Reconcile Employee Payroll",

      "Employee Payroll Reports",

      "Hr Payroll Approver",
      "Senior Hr Payroll Approver",

      "View To-Finance Payroll",
      "Submit To-Finance Payroll",
      "View Salary Increments",
      "Maintain Salary Increments",
      "Approve Salary Increments",

      "View Employee Allowances",
      "Maintain Employee Allowances",
      "Approve Employee Allowances",

      "View Employee Deductions",
      "Maintain Employee Deductions",
      "Approve Employee Deductions",

      "View Staff Loans",
      "Maintain Staff Loans",
      "Approve Staff Loans",
    ],
    submenu: [
      {
        path: "/erp-hr/payroll/payroll-dashboard",
        title: "Payroll Dashboard",
        moduleName: "payroll",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["View Employee Payroll"],
        submenu: [],
      },
      {
        path: "/erp-hr/payroll/open-payroll",
        title: "1. Open Payroll",
        moduleName: "payroll",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Open and Close Payroll"],
        submenu: [],
      },
      {
        path: "/erp-hr/payroll/salary-increment-payroll",
        title: "2. Salary Increment",
        moduleName: "payroll",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Salary Increments",
          "Maintain Salary Increments",
          "Approve Salary Increments",
        ],
        submenu: [],
      },
      {
        path: "/erp-hr/payroll/recursive-allowance-payroll",
        title: "3. Add Recursive Allowance",
        moduleName: "payroll",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Employee Allowances",
          "Maintain Employee Allowances",
          "Approve Employee Allowances",
        ],
        submenu: [],
      },
      {
        path: "/erp-hr/payroll/allowance-payroll",
        title: "4. Other One-Time Allowance",
        moduleName: "payroll",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Employee Allowances",
          "Maintain Employee Allowances",
          "Approve Employee Allowances",
        ],
        submenu: [],
      },

      {
        path: "/erp-hr/payroll/deductions-payroll",
        title: "5. One time Deductions",
        moduleName: "payroll",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Employee Deductions",
          "Maintain Employee Deductions",
          "Approve Employee Deductions",
        ],
        submenu: [],
      },

      {
        path: "/erp-hr/payroll/recursive-deduction-payroll",
        title: "6. Recursive Deductions",
        moduleName: "payroll",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Employee Deductions",
          "Maintain Employee Deductions",
          "Approve Employee Deductions",
        ],
        submenu: [],
      },

      {
        path: "/erp-hr/payroll/distributed-deduction-payroll",
        title: "7. Distributed Deductions",
        moduleName: "payroll",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Employee Deductions",
          "Maintain Employee Deductions",
          "Approve Employee Deductions",
        ],
        submenu: [],
      },

      {
        path: "/erp-hr/payroll/sacco-contribution",
        title: "8. Sacco Contributions",
        moduleName: "payroll",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Employee Deductions",
          "Maintain Employee Deductions",
          "Approve Employee Deductions",
        ],
        submenu: [],
      },


      {
        path: "/erp-hr/payroll/staff-loans-payroll",
        title: "9. Staff Loans",
        moduleName: "payroll",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Staff Loans",
          "Maintain Staff Loans",
          "Approve Staff Loans",
        ],
        submenu: [],
      },
      {
        path: "/erp-hr/payroll/sacco-loan",
        title: "10. Sacco Loans",
        moduleName: "payroll",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Staff Loans",
          "Maintain Staff Loans",
          "Approve Staff Loans",
        ],
        submenu: [],
      },

      {
        path: "/erp-hr/payroll/helb-deduction-payroll",
        title: "11. Helb Deductions",
        moduleName: "payroll",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Employee Deductions",
          "Maintain Employee Deductions",
          "Approve Employee Deductions",
        ],
        submenu: [],
      },

      {
        path: "/erp-hr/payroll/bifu-deduction-payroll",
        title: "12. Bifu Deductions",
        moduleName: "payroll",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Employee Deductions",
          "Maintain Employee Deductions",
          "Approve Employee Deductions",
        ],
        submenu: [],
      },

      {
        path: "/erp-hr/payroll/generate-payroll",
        title: "13. Generate Payroll",
        moduleName: "payroll",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Open and Close Payroll"],
        submenu: [],
      },

      {
        path: "/erp-hr/payroll/reconcile-payroll",
        title: "14. Reconcile Payroll",
        moduleName: "payroll",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Reconcile Employee Payroll"],
        submenu: [],
      },

      {
        path: "/erp-hr/payroll/close-payroll",
        title: "15. Close Payroll",
        moduleName: "payroll",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Open and Close Payroll"],
        submenu: [],
      },

      {
        path: "/erp-hr/payroll/reports-payroll",
        title: "16. Payroll Reports",
        moduleName: "payroll",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Employee Payroll Reports"],
        submenu: [],
      },

      {
        path: "/erp-hr/payroll/to-finance-payroll",
        title: "17. To Finance",
        moduleName: "payroll",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Submit To-Finance Payroll"],
        submenu: [],
      },
      {
        path: "/erp-hr/payroll/manage-payslips-payroll",
        title: "18. Manage Payslip",
        moduleName: "payroll",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Open Payslips"],
        submenu: [],
      },
      {
        path: "/erp-hr/payroll/process-payslips-payroll",
        title: "19. Process Payslips",
        moduleName: "payroll",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Open Payslips"],
        submenu: [],
      },

      {
        path: "/erp-hr/payroll/process-p-9-payroll",
        title: "20. Payroll P9s",
        moduleName: "payroll",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Download Payslips and P9"],
        submenu: [],
      },

      {
        path: "/erp-hr/payroll/gratuity-payroll",
        title: "21. Gratuity",
        moduleName: "payroll",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Gratuity"],
        submenu: [],
      },
    ],
  },

  {
    path: "/erp-hr/leave-management/all-leave-requests",
    title: "Leave Management",
    moduleName: "leave",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: [
      "View Employee Leave",
      "Maintain Employee Leave",
      " Supervisor Leave Approver",
      "Human Resource Leave Approver",
    ],
    submenu: [],
  },

  {
    path: "",
    title: "KPI Management",
    moduleName: "performance",
    iconType: "feather",
    icon: "grid",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: [
      "View Employee KPI",
      "Maintain Employee KPI",
      "Supervisor KPI Approver",
      "Human Resource KPI Approver",
    ],
    submenu: [
      {
        path: "/erp-hr/kpi-management/all-kpi-goals",
        title: "KPI Goal",
        moduleName: "performance",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Employee KPI",
          "Maintain Employee KPI",
          "Supervisor KPI Approver",
          "Human Resource KPI Approver",
        ],
        submenu: [],
      },
      {
        path: "/erp-hr/kpi-management/kpi-results",
        title: "KPI Results",
        moduleName: "performance",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Employee KPI",
          "Maintain Employee KPI",
          "Supervisor KPI Approver",
          "Human Resource KPI Approver",
        ],
        submenu: [],
      },
    ],
  },

  {
    path: "/erp-hr/exit-management/all-exit-requests",
    title: "Exit Management",
    moduleName: "exit",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: [
      "View Employee Exits",
      "Maintain Employee Exits",
      "Approve Employee Exits",
    ],
    submenu: [],
  },

  {
    path: "",
    title: "Case Management",
    moduleName: "case",
    iconType: "feather",
    icon: "grid",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: [
      "View Employee Case",
      "View Employee Case Investigation",
      "Maintain Employee Case",
      "Approve Employee Case",
    ],
    submenu: [
      {
        path: "/erp-hr/case-management/all-cases-raised",
        title: "Cases Raised",
        moduleName: "case",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "View Employee Case",
          "View Employee Case Investigation",
          "Maintain Employee Case",
          "Approve Employee Case",
        ],
        submenu: [],
      },
      {
        path: "/erp-hr/case-management/all-case-investigations",
        title: "Case Investigations",
        moduleName: "case",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["View Employee Case Investigation"],
        submenu: [],
      },
    ],
  },

  {
    path: "/erp-hr/shared-documents/all-shared-documents",
    title: "Shared Documents",
    moduleName: "documents",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: [
      "View Shared Documents",
      "Maintain Shared Documents",
      "Approve Shared Documents",
    ],
    submenu: [],
  },

  {
    path: "/erp-hr/learning-and-training/all-learning-and-training",
    title: "Learning And Training",
    moduleName: "learning",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: [
      "View Learning and Training",
      "Maintain Learning and Training",
      "Approve Learning and Training",
    ],
    submenu: [],
  },

  {
    path: "/erp-hr/hr-miscellaneous/bulk-uploads",
    title: "Bulk Uploads",
    moduleName: "bulk-uploads",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: [
      "View Configuration",
      "Maintain Configuration",
      "Approve Configuration",
    ],
    submenu: [],
  },
];

export const HumanResourceSelfServiceModule: RouteInfo[] = [
  //************************************************************************************************************************* */
  //HumanResourceSelfServiceModule
  //************************************************************************************************************************* */
  {
    path: "",
    title: "MENUITEMS.MAIN.TEXT",
    moduleName: "",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All"],
    submenu: [],
  },

  {
    path: "/erp-hr-self-service/dashboard",
    title: "Dashboard",
    moduleName: "dashboard",
    iconType: "feather",
    icon: "monitor",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All"],
    submenu: [],
  },

  {
    path: "/erp-hr-self-service/employee-profile/my-profile",
    title: "My Profile",
    moduleName: "profile",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All"],
    submenu: [],
  },
  {
    path: "/erp-hr-self-service/employee-profile/all-employee-documents",
    title: "Employee Documents",
    moduleName: "profile",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },
  {
    path: "/erp-hr-self-service/employee-payroll",
    title: "Payroll Details",
    moduleName: "payroll",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All"],
    submenu: [],
  },

  {
    path: "/erp-hr-self-service/employee-kpi",
    title: "KPI Details",
    moduleName: "KPI",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All"],
    submenu: [],
  },
  {
    path: "/erp-hr-self-service/employee-leave/requests",
    title: "Leave Details",
    moduleName: "leave",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All"],
    submenu: [
      // {
      //   path: "/erp-hr-self-service/employee-leave/requests",
      //   title: "Applied Leaves",
      //   moduleName: "leaves",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   role: [""],
      //   privilege: ["All"],
      //   submenu: [],
      // },
      // {
      //   path: "/erp-hr-self-service/employee-leave/plan",
      //   title: "Planned Leaves",
      //   moduleName: "leaves",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   role: [""],
      //   privilege: ["All"],
      //   submenu: [],
      // },
      // {
      //   path: "/erp-hr-self-service/dashboard",
      //   title: "Leave Reports",
      //   moduleName: "leaves",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   role: [""],
      //   privilege: ["All"],
      //   submenu: [],
      // },
    ],
  },

  {
    path: "/erp-hr-self-service/employee-learning",
    title: "Learning And Training",
    moduleName: "KPI",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All"],
    submenu: [],
  },
  {
    path: "/erp-hr-self-service/employee-case",
    title: "Disciplinary Cases",
    moduleName: "cases",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All"],
    submenu: [],
  },
  {
    path: "/erp-hr-self-service/employee-search/employees",
    title: "Search Employee",
    moduleName: "search",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All"],
    submenu: [],
  },
  {
    path: "/erp-hr-self-service/employee-shared-documents",
    title: "Shared Documents",
    moduleName: "documents",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All"],
    submenu: [],
  },

  {
    path: "",
    title: "Job Vacancies",
    moduleName: "job",
    iconType: "feather",
    icon: "grid",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All"],
    submenu: [
      {
        path: "/erp-hr-self-service/employee-jobs/openings",
        title: "Job Openings",
        moduleName: "job",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All"],
        submenu: [],
      },
      {
        path: "/erp-hr-self-service/employee-jobs/applied",
        title: "Jobs Applied",
        moduleName: "job",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All"],
        submenu: [],
      },
      {
        path: "/erp-hr-self-service/employee-jobs/interviewScores",
        title: "Interviews Scores",
        moduleName: "job",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All"],
        submenu: [],
      },
    ],
  },

  //employee-transfer
  {
    path: "/erp-hr-self-service/employee-transfer",
    title: "Transfer Requests",
    moduleName: "employee-transfer",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All"],
    submenu: [],
  },
  {
    path: "/erp-hr-self-service/employee-exit",
    title: "Exit Request",
    moduleName: "exit",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All"],
    submenu: [],
  },

  {
    path: "/erp-hr-self-service/employee-miscellaneous/staff-loans",
    title: "Staff Loans",
    moduleName: "employee-miscellaneous",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All"],
    submenu: [],
  },
];
export const ProcurementModule: RouteInfo[] = [
  //************************************************************************************************************************* */
  //PROCURMENT
  //************************************************************************************************************************* */
  {
    path: "",
    title: "MENUITEMS.MAIN.TEXT",
    moduleName: "",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },

  {
    path: "/erp-procurement/dashboard",
    title: "Dashboard",
    moduleName: "dashboard",
    iconType: "feather",
    icon: "monitor",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },
  // {
  //   path: "",
  //   title: "PARAMETER SETTINGS",
  //   moduleName: "",
  //   iconType: "",
  //   icon: "",
  //   class: "",
  //   groupTitle: true,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["All"],
  //   privilege: [
  //     "Add Budget Categories",
  //     "Manage Budget Categories",
  //     "All Budgets",
  //     "Manage Budgets",
  //     "All Procurement Committees",
  //     "Manage Procurement Committees",
  //     "All Suppliers",
  //     "Manage Suppliers",
  //     "All Currencies",
  //     "Manage Currencies",
  //     "Approved RFPS",
  //     "All Branch Stores",
  //     "Manage Branch Stores",
  //   ],
  //   submenu: [],
  // },

  //Budget
  // {
  //   path: "",
  //   title: "Budget",
  //   moduleName: "budget",
  //   iconType: "feather",
  //   icon: "grid",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: [""],
  //   privilege: ["All Budgets", "Manage Budgets"],
  //   submenu: [
  //     {
  //       path: "/erp-procurement/parameters/all-budgets",
  //       title: "All Budgets",
  //       moduleName: "budgets",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["All Budgets"],
  //       submenu: [],
  //     },
  //     {
  //       path: "/erp-procurement/parameters/manage-budgets",
  //       title: "Manage Budgets",
  //       moduleName: "lease",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["Manage Budgets"],
  //       submenu: [],
  //     },
  //   ],
  // },

  //Sub modules
  {
    path: "",
    title: "Procurement Sub-modules",
    moduleName: "",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All Needs", "Manage Needs"],
    submenu: [],
  },

  //  Customer Management
  // {
  //   path: "",
  //   title: "Customer Management",
  //   moduleName: "customers",
  //   iconType: "feather",
  //   icon: "grid",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: [""],
  //   privilege: ["All Customers", "Manage Customers"],
  //   submenu: [
  //     {
  //       path: "/erp-procurement/customer-management/all-customer-types",
  //       title: "All Customer Types",
  //       moduleName: "customers",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["All Customers"],

  //       submenu: [],
  //     },
  //     {
  //       path: "/erp-procurement/customer-management/manage-customer-types",
  //       title: "Manage Customer Types",
  //       moduleName: "customers",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["Manage Customers"],
  //       submenu: [],
  //     },
  //     {
  //       path: "/erp-procurement/customer-management/all-customers",
  //       title: "All Customers",
  //       moduleName: "customers",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["All Customers"],

  //       submenu: [],
  //     },
  //     {
  //       path: "/erp-procurement/customer-management/manage-customers",
  //       title: "Manage Customer",
  //       moduleName: "customers",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["Manage Customers"],
  //       submenu: [],
  //     },
  //   ],
  // },


  // {
  //   path: "",
  //   title: "Landlord Management",
  //   moduleName: "landlords",
  //   iconType: "feather",
  //   icon: "grid",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: [""],
  //   privilege: ["All landlords", "Manage landlords"],
  //   submenu: [

  //     {
  //       path: "/erp-procurement/property-owner-management/all-landlords",
  //       title: "All Landlords",
  //       moduleName: "landlords",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["All Landlords"],

  //       submenu: [],
  //     },
  //     {
  //       path: "/erp-procurement/property-owner-management/manage-landlords",
  //       title: "Manage Landlord",
  //       moduleName: "landlords",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["Manage landlords"],
  //       submenu: [],
  //     },
  //   ],
  // },

  {
    path: "",
    title: "Procurement Committee",
    moduleName: "procurement-module",
    iconType: "feather",
    icon: "list",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All Committees", "Manage Committee"],
    submenu: [
      {
        path: "/erp-procurement/parameters/all-procurement-committees",
        title: "All Committees",
        moduleName: "procurement-module",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All Committees"],
        submenu: [],
      },
      {
        path: "/erp-procurement/parameters/manage-procurement-committees",
        title: "Manage Committee",
        moduleName: "procurement-module",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Manage Committee"],
        submenu: [],
      },
    ],
  },
  //Needs
  {
    path: "",
    title: "Purchase Requisition",
    moduleName: "needs",
    iconType: "feather",
    icon: "grid",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All Needs", "Manage Needs"],
    submenu: [
      {
        path: "/erp-procurement/needs/all-needs",
        title: "All Requisitions",
        moduleName: "needs",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All Needs"],
        submenu: [],
      },
      {
        path: "/erp-procurement/needs/manage-need",
        title: "Manage Requisitions",
        moduleName: "needs",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Manage Needs"],
        submenu: [],
      },
    ],
  },


  //RFPs

  {
    path: "",
    title: "RFPs",
    moduleName: "RFPs",
    iconType: "feather",
    icon: "grid",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All RFPs", "Manage RFPs"],
    submenu: [
      {
        path: "/erp-procurement/rfps/all-rfps",
        title: "All RFPs",
        moduleName: "RFPs",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All RFPs"],
        submenu: [],
      },

      {
        path: "/erp-procurement/rfps/manage-rfp",
        title: "Manage RFP",
        moduleName: "RFPs",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Manage RFPs"],
        submenu: [],
      },
    ],
  },

  //Recieve RFP Appications
  {
    path: "/erp-procurement/rfp-applications/analyse-rfp-applications",
    title: "Recieve RFP Applications",
    moduleName: "recieverfpapplication",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All Rfp Applications", "Analyse Rfp Applications"],
    submenu: [
      // {
      //   path: "/erp-procurement/rfp-applications/all-rfp-appications",
      //   title: "All RFP Applications",
      //   moduleName: "recieverfpapplication",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   role: [""],
      //   privilege: ["All Rfp Applications"],
      //   submenu: [],
      // },
      // {
      //   path: "/erp-procurement/rfp-applications/analyse-rfp-applications",
      //   title: "Analyse RFP Applications",
      //   moduleName: "recieverfpapplication",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   role: [""],
      //   privilege: ["Analyse Rfp Applications"],
      //   submenu: [],
      // },
    ],
  },


  //RFQs

  {
    path: "",
    title: "RFQs",
    moduleName: "RFQs",
    iconType: "feather",
    icon: "grid",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All Rfqs", "Manage Rfqs"],
    submenu: [
      {
        path: "/erp-procurement/rfqs/all-rfqs",
        title: "All RFQs",
        moduleName: "RFPs",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All Rfqs"],
        submenu: [],
      },

      {
        path: "/erp-procurement/rfqs/manage-rfqs",
        title: "Manage RFQ",
        moduleName: "RFQs",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Manage Rfqs"],
        submenu: [],
      },
    ],
  },

  //Recieve RFQ Appications
  {
    path: "/erp-procurement/rfq-applications/analyse-rfq-applications",
    title: "Recieve Rfq Applications",
    moduleName: "recieverfqapplication",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All Rfq Applications"],
    submenu: [
      // {
      //   path: "/erp-procurement/rfq-applications/all-rfq-appications",
      //   title: "All Rfq Applications",
      //   moduleName: "recieverfqapplication",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   role: [""],
      //   privilege: ["All Rfq Applications"],
      //   submenu: [],
      // },
      // {
      //   path: "/erp-procurement/rfq-applications/analyse-rfq-applications",
      //   title: "Analyse Rfq Applications",
      //   moduleName: "recieverfqapplication",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   role: [""],
      //   privilege: ["Analyse Rfq Applications"],
      //   submenu: [],
      // },
    ],
  },


  // {
  //   path: "",
  //   title: "RFP's Management",
  //   moduleName: "rfps",
  //   iconType: "feather",
  //   icon: "grid",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: [""],
  //   privilege: ["All RFPs", "Manage RFPs", "Approved RFPS"],
  //   submenu: [
  //     {
  //       path: "/erp-procurement/rfqs/all-rfqs",
  //       title: "All RFP's",
  //       moduleName: "rfps",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["All RFPs"],
  //       submenu: [],
  //     },
  //     {
  //       path: "/erp-procurement/rfps/manage-rfps",
  //       title: "Manage RFP's",
  //       moduleName: "lease",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["Manage RFPs"],
  //       submenu: [],
  //     },
  //     {
  //       path: "/erp-procurement/rfps/approved-rfps",
  //       title: "Approved RFP's",
  //       moduleName: "lease",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["Approved RFPS"],
  //       submenu: [],
  //     },
  //   ],
  // },

  //Purchase Order
  {
    path: "",
    title: "Purchase Order",
    moduleName: "requisition",
    iconType: "feather",
    icon: "grid",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All Requisitions", "Manage Requisitions"],
    submenu: [
      {
        path: "/erp-procurement/requisitions/all-requisitions",
        title: "All Purchase Orders",
        moduleName: "requisition",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All Requisitions"],
        submenu: [],
      },
      {
        path: "/erp-procurement/requisitions/manage-requisitions",
        title: "Manage Purchase Order",
        moduleName: "requisition",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Manage Requisitions"],
        submenu: [],
      },
    ],
  },

  // {
  //   path: "/erp-procurement/received/all-received-items",
  //   title: "Received Items",
  //   moduleName: "received-items",
  //   iconType: "feather",
  //   icon: "grid",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: [""],
  //   privilege: ["All Received Items"],
  //   submenu: [],
  // },

  // Add this Privileges kwa procurement:

  // Receive Purchase Order Items
  // Received Stocks
  // Received Fixed Assets
  // Received Expenses
  // Received Prepayments

  {
    path: "",
    title: "Received Items",
    moduleName: "received-items",
    iconType: "feather",
    icon: "grid",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: [
      "Received Stocks",
      "Received Fixed Assets",
      "Received Expenses",
      "Received Prepayments",
    ],
    submenu: [
      {
        path: "/erp-procurement/received/received-stocks",
        title: "Stocks",
        moduleName: "received-items",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Received Stocks"],
        submenu: [],
      },
      {
        path: "/erp-procurement/received/received-fixed-assets",
        title: "Fixed Assets",
        moduleName: "received-items",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Received Fixed Assets"],
        submenu: [],
      },
      {
        path: "/erp-procurement/received/received-expenses",
        title: "Expenses",
        moduleName: "received-items",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Received Expenses"],
        submenu: [],
      },
      // {
      //   path: "/erp-procurement/received/received-prepayments",
      //   title: "Prepayments",
      //   moduleName: "received-items",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   role: [""],
      //   privilege: ["Received Prepayments"],
      //   submenu: [],
      // },
    ],
  },

  {
    path: "",
    title: "Supplier Invoices",
    moduleName: "SupplierInvoices",
    iconType: "feather",
    icon: "grid",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: [
      "All Supplier Invoices",
      "Manage Supplier Invoices",
    ],
    submenu: [
      {
        path: "/erp-procurement/received/all-supplier-invoices",
        title: "All Supplier Invoices",
        moduleName: "SupplierInvoices",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All Supplier Invoices"],
        submenu: [],
      },
      // {
      //   path: "/erp-procurement/received/manage-supplier-invoice",
      //   title: "Manage Supplier Invoices",
      //   moduleName: "SupplierInvoices",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   role: [""],
      //   privilege: ["Manage Supplier Invoices", "Dashboard"],
      //   submenu: [],
      // },
    ],
  },

  // {
  //   path: "",
  //   title: "Customer Invoices",
  //   moduleName: "Receivables",
  //   iconType: "feather",
  //   icon: "grid",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: [""],
  //   privilege: [
  //     "All Customer Invoices",
  //     "Manage Customer Invoices",
  //   ],
  //   submenu: [
  //     {
  //       path: "/erp-procurement/receivable/all-customer-invoices",
  //       title: "All Customer Invoices",
  //       moduleName: "Receivables",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["All Customer Invoices"],
  //       submenu: [],
  //     },
  //     {
  //       path: "/erp-procurement/receivable/manage-customer-invoices",
  //       title: "Manage Customer Invoices",
  //       moduleName: "Receivables",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["Manage Customer Invoices"],
  //       submenu: [],
  //     },
  //   ],
  // },

  //Property Owner Invoice
  // {
  //   path: "",
  //   title: "Landlord Invoices",
  //   moduleName: "LandlordInvoices",
  //   iconType: "feather",
  //   icon: "grid",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: [""],
  //   privilege: [
  //     "All Landlord Invoices",
  //     "Manage Landlord Invoices",
  //   ],
  //   submenu: [
  //     {
  //       path: "/erp-procurement/property-owner-invoice/all-property-owner-invoices",
  //       title: "All Landlord Invoices",
  //       moduleName: "LandlordInvoices",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["All Landlord Invoices"],
  //       submenu: [],
  //     },
  //     {
  //       path: "/erp-procurement/property-owner-invoice/manage-property-owner-invoices",
  //       title: "Manage Landlord Invoices",
  //       moduleName: "LandlordInvoices",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["Manage Landlord Invoices"],
  //       submenu: [],
  //     },
  //   ],
  // },

  // Supplier Q&A Board
  {
    path: "/erp-procurement/faq-board",
    title: "Supplier Q&A Board",
    moduleName: "faq-admin",
    iconType: "material",
    icon: "forum",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },

];

export const FinanceModule: RouteInfo[] = [
  //************************************************************************************************************************* */
  //FINANCE
  //************************************************************************************************************************* */
  {
    path: "",
    title: "MENUITEMS.MAIN.TEXT",
    moduleName: "",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },

  {
    path: "/erp-finance/dashboard",
    title: "Dashboard",
    moduleName: "dashboard",
    iconType: "feather",
    icon: "monitor",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },
  {
    path: "",
    title: "PARAMETER SETTINGS",
    moduleName: "",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All Currencies", "Manage Currencies"],
    submenu: [],
  },

  {
    path: "",
    title: "Finance Elements",
    moduleName: "multilevel",
    iconType: "feather",
    icon: "grid",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    privilege: ["Dashboard"],
    submenu: [
      // GL Accounts

      {
        path: "",
        title: "GL Accounts",
        moduleName: "GL's",
        iconType: "feather",
        icon: "grid",
        class: "ml-sub-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All GL-Accounts", "Manage GL-Accounts"],
        submenu: [
          {
            path: "/erp-finance/finance-parameters/all-GLs",
            title: "All GL Accounts",
            moduleName: "GL'S",
            iconType: "",
            icon: "",
            class: "ml-menu",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            role: [""],
            privilege: ["All GL-Accounts"],
            submenu: [],
          },
          {
            path: "/erp-finance/finance-parameters/manage-GLs",
            title: "Manage GL Accounts",
            moduleName: "GL'S",
            iconType: "",
            icon: "",
            class: "ml-menu",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            role: [""],
            privilege: ["Manage GL-Accounts"],
            submenu: [],
          },
        ],
      },
      {
        path: "/erp-finance/finance-parameters/manage-gl-mapping-for-accounting",
        title: "GL Mapping (Accounting)",
        moduleName: "gl-mapping",
        iconType: "feather",
        icon: "grid",
        class: "ml-sub-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Dashboard"],
        submenu: [],
      },

      //Cost Centres
      {
        path: "",
        title: "Cost Centres",
        moduleName: "costcentres",
        iconType: "feather",
        icon: "grid",
        class: "ml-sub-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All Costcenters", "Manage Costcenters"],
        submenu: [
          {
            path: "/erp-finance/finance-parameters/all-CCentres",
            title: "All Cost Centres",
            moduleName: "budgets",
            iconType: "",
            icon: "",
            class: "ml-menu",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            role: [""],
            privilege: ["All Costcenters"],
            submenu: [],
          },
          {
            path: "/erp-finance/finance-parameters/manage-CCentres",
            title: "Manage Cost Centres",
            moduleName: "budgets",
            iconType: "",
            icon: "",
            class: "ml-menu",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            role: [""],
            privilege: ["Manage Costcenters"],
            submenu: [],
          },
        ],
      },


      //Branch/department management
      {
        path: "",
        title: "Sol Configurations",
        moduleName: "BranchConfigurations",
        iconType: "feather",
        icon: "grid",
        class: "ml-sub-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All Sol Configurations", "Manage Sol Configurations"],
        submenu: [
          {
            path: "/erp-finance/finance-parameters/all-branch-configurations",
            title: "All Sol Configurations",
            moduleName: "budgets",
            iconType: "",
            icon: "",
            class: "ml-menu",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            role: [""],
            privilege: ["All Sol Configurations"],
            submenu: [],
          },
          {
            path: "/erp-finance/finance-parameters/manage-branch-configurations",
            title: "Manage Sol Configurations",
            moduleName: "Finance",
            iconType: "",
            icon: "",
            class: "ml-menu",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            role: [""],
            privilege: ["Manage Sol Configurations"],
            submenu: [],
          },
        ],
      },

      //Expenses
      {
        path: "",
        title: "Expenses",
        moduleName: "expenses",
        iconType: "feather",
        icon: "grid",
        class: "ml-sub-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All Expenses", "Manage Expenses"],
        submenu: [
          {
            path: "/erp-finance/finance-parameters/all-expenses",
            title: "All Expenses",
            moduleName: "expenses",
            iconType: "",
            icon: "",
            class: "ml-menu",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            role: [""],
            privilege: ["All Expenses"],
            submenu: [],
          },
          {
            path: "/erp-finance/finance-parameters/manage-expenses",
            title: "Manage Expenses",
            moduleName: "expenses",
            iconType: "",
            icon: "",
            class: "ml-menu",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            role: [""],
            privilege: ["Manage Expenses"],
            submenu: [],
          },
        ],
      },

      // Currency Management
      {
        path: "",
        title: "Currencies",
        moduleName: "currencies",
        iconType: "feather",
        icon: "grid",
        class: "ml-sub-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All Currencies"],
        submenu: [
          {
            path: "/erp-finance/finance-parameters/all-currency",
            title: "All Currencies",
            moduleName: "currency-management",
            iconType: "",
            icon: "",
            class: "ml-menu",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            role: [""],
            privilege: ["All Currencies", "Manage Currencies"],
            submenu: [],
          },
          {
            path: "/erp-finance/finance-parameters/manage-currency",
            title: "Manage Currencies",
            moduleName: "currency-management",
            iconType: "",
            icon: "",
            class: "ml-menu",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            role: [""],
            privilege: ["Manage Currencies"],
            submenu: [],
          },
        ],
      },
      //All taxes
      {
        path: "",
        title: "Taxes",
        moduleName: "tax",
        iconType: "feather",
        icon: "grid",
        class: "ml-sub-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All Taxes", "Manage Taxes"],
        submenu: [
          {
            path: "/erp-finance/finance-parameters/all-taxes",
            title: "All Taxes",
            moduleName: "tax",
            iconType: "",
            icon: "",
            class: "ml-menu",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            role: [""],
            privilege: ["All Taxes"],
            submenu: [],
          },
          {
            path: "/erp-finance/finance-parameters/manage-taxes",
            title: "Manage Taxes",
            moduleName: "tax",
            iconType: "",
            icon: "",
            class: "ml-menu",
            groupTitle: false,
            badge: "",
            badgeClass: "",
            role: [""],
            privilege: ["Manage Taxes"],
            submenu: [],
          },
        ],
      },

      //Approval Limits
      {
        path: "/erp-finance/finance-parameters/all-approval-limits",
        title: "Approval Limits",
        moduleName: "approval-limits",
        iconType: "feather",
        icon: "grid",
        class: "",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: [
          "All Approval Limits",
          "Manage Approval Limits",
          "Dashboard",
        ],
        submenu: [
          // {
          //   path: "/erp-finance/finance-parameters/all-approval-limits",
          //   title: "All Approval Limits",
          //   moduleName: "tax",
          //   iconType: "",
          //   icon: "",
          //   class: "ml-menu",
          //   groupTitle: false,
          //   badge: "",
          //   badgeClass: "",
          //   role: [""],
          //   privilege: ["All Approval Limits", "Dashboard"],
          //   submenu: [],
          // },
          // {
          //   path: "/erp-finance/finance-parameters/manage-approval-limits",
          //   title: "Manage Approval Limits",
          //   moduleName: "tax",
          //   iconType: "",
          //   icon: "",
          //   class: "ml-menu",
          //   groupTitle: false,
          //   badge: "",
          //   badgeClass: "",
          //   role: [""],
          //   privilege: ["Manage Approval Limits", "Dashboard"],
          //   submenu: [],
          // },
        ],
      },
    ],
  },

  //payment Methods
  // {
  //   path: "",
  //   title: "Payment Methods",
  //   moduleName: "payment",
  //   iconType: "feather",
  //   icon: "grid",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: [""],
  //   privilege: ["All Customers", "Manage Customers"],
  //   submenu: [
  //     {
  //       path: "/erp-finance/finance-parameters/all-PaymentMethods",
  //       title: "All Payment Methods",
  //       moduleName: "currency-management",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["All Customers"],
  //       submenu: [],
  //     },
  //     {
  //       path: "/erp-finance/finance-parameters/manage-PaymentMethods",
  //       title: "Manage Payment Methods",
  //       moduleName: "payment-management",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["Manage Customers"],
  //       submenu: [],
  //     },
  //   ],
  // },

  // Customer Types
  // {
  //   path: "",
  //   title: "Customer Types",
  //   moduleName: "customer-types",
  //   iconType: "feather",
  //   icon: "grid",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: [""],
  //   privilege: ["All Customers", "Manage Customers"],
  //   submenu: [

  //   ],
  // },

  //  Customer Management
  // {
  //   path: "",
  //   title: "Customer Management",
  //   moduleName: "customers",
  //   iconType: "feather",
  //   icon: "grid",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: [""],
  //   privilege: ["All Customers", "Manage Customers"],
  //   submenu: [
  //     {
  //       path: "/erp-finance/finance-parameters/all-CustomerTypes",
  //       title: "Customer Types",
  //       moduleName: "customers",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["All Customers"],
  //       submenu: [],
  //     },
  //     {
  //       path: "/erp-finance/finance-parameters/manage-CustomerTypes",
  //       title: "Manage Types",
  //       moduleName: "customers",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["Manage Customers"],
  //       submenu: [],
  //     },
  //     {
  //       path: "/erp-finance/finance-management/all-customers",
  //       title: "All Customers",
  //       moduleName: "customers",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["All Customers"],
  //       submenu: [],
  //     },
  //     {
  //       path: "/erp-finance/finance-management/manage-customers",
  //       title: "Manage Customer",
  //       moduleName: "customers",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["Manage Customers"],
  //       submenu: [],
  //     },
  //   ],
  // },

  {
    path: "",
    title: "Finance Sub-modules",
    moduleName: "",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },

  // SUBMODULES
  {
    path: "/erp-finance/finance-management/all-imprests",
    title: "Imprest Management",
    moduleName: "imprest-management",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All Imprest", "Manage Imprest", "Imprest Validation"],
    submenu: [
      // {
      //   path: "/erp-finance/finance-management/all-imprests",
      //   title: "All Imprests",
      //   moduleName: "imprest-management",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   role: [""],
      //   privilege: ["All Imprest"],
      //   submenu: [],
      // },
    ],
  },

  // SUBMODULES


  {
    path: "",
    title: "Salary Management",
    moduleName: "salaries",
    iconType: "feather",
    icon: "grid",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All Salaries", "Manage Salaries", "Salary Validation"],
    submenu: [
      {
        path: "/erp-finance/finance-management/all-salaries",
        title: "All Salaries",
        moduleName: "salaries",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All Salaries"],
        submenu: [],
      },
      {
        path: "/erp-finance/finance-management/salary-analytics",
        title: "Salary Analytics",
        moduleName: "salaries",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Manage Salaries"],
        submenu: [],
      },
    ],
  },
  {
    path: "",
    title: "Customer Invoices",
    moduleName: "customer-invoices",
    iconType: "feather",
    icon: "grid",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All Customer Invoices", "Manage Customer Invoices"],
    submenu: [
      {
        path: "/erp-finance/finance-management/all-cusInvoices",
        title: "All Customer Invoices",
        moduleName: "Finance-management",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All Customer Invoices"],
        submenu: [],
      },
      // {
      //   path: "/erp-finance/finance-management/manage-cusInvoices",
      //   title: "Manage Customer Invoices",
      //   moduleName: "Finance-management",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   role: [""],
      //   privilege: ["Manage Customer Invoices"],
      //   submenu: [],
      // },
    ],
  },

  // Supplier Invoices
  {
    path: "/erp-finance/finance-management/allSupplierInvoices",
    title: "Supplier Invoices",
    moduleName: "Account-Payable",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All Supplier Invoices", "Manage Supplier Invoices"],
    submenu: [
      // {
      //   path: "/erp-finance/finance-management/allSupplierInvoices",
      //   title: "All Supplier Invoices",
      //   moduleName: "Finance-management",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   role: [""],
      //   privilege: ["All Supplier Invoices"],
      //   submenu: [],
      // },
      // {
      //   path: "/erp-finance/finance-management/manageSupplierInvoices",
      //   title: "Manage Supplier Invoices",
      //   moduleName: "Finance-management",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   role: [""],
      //   privilege: ["Manage Supplier Invoices"],
      //   submenu: [],
      // },
    ],
  },


  // Other Payments

  {
    path: "",
    title: "Other Payables",
    moduleName: "Accounts-Payable",
    iconType: "feather",
    icon: "grid",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All Accounts Payable", "Manage Accounts Payable"],
    submenu: [
      {
        path: "/erp-finance/finance-management/allAccountsPayable",
        title: "All Other Payables",
        moduleName: "Finance-management",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All Accounts Payable"],
        submenu: [],
      },
      {
        path: "/erp-finance/finance-management/manageAccountsPayable",
        title: "Manage Other Payables",
        moduleName: "Finance-management",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Manage Accounts Payable"],
        submenu: [],
      },
    ],
  },



  // Payable Payments

  {
    path: "",
    title: "Payable Payments",
    moduleName: "payablePayments",
    iconType: "feather",
    icon: "grid",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All Accounts Payable", "Manage Accounts Payable"],
    submenu: [
      {
        path: "/erp-finance/finance-management/postPayablesToCore/supplier",
        title: "Supplier Payments",
        moduleName: "payablePayments",
        iconType: "feather",
        icon: "grid",
        class: "",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All Supplier Invoices", "Manage Supplier Invoices"],
        submenu: [
        ],
      },
          {
        path: "/erp-finance/finance-management/postPayablesToCore/landlord",
        title: "Landlord Payments",
        moduleName: "payablePayments",
        iconType: "feather",
        icon: "grid",
        class: "",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All Supplier Invoices", "Manage Supplier Invoices"],
        submenu: [
        ],
      },
    ],
  },
  // {
  //   path: "/erp-finance/finance-management/postPayablesToCore",
  //   title: "Payable Payments",
  //   moduleName: "payablePayments",
  //   iconType: "feather",
  //   icon: "grid",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: [""],
  //   privilege: ["All Supplier Invoices", "Manage Supplier Invoices"],
  //   submenu: [
  //   ],
  // },


  //Sub-Module (Accounts Receivables)
  //Customer invoices


  // Receivable Payments
  {
    path: "",
    title: "Receivable Payments",
    moduleName: "Account-Receivable",
    iconType: "feather",
    icon: "grid",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All Receivable Payments", "Manage Receivable Payments"],
    submenu: [
      {
        path: "/erp-finance/finance-management/all-recPayments",
        title: "All Receivable Payments",
        moduleName: "Finance-management",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All Receivable Payments"],
        submenu: [],
      },
      // {
      //   path: "/erp-finance/finance-management/manage-recPayments",
      //   title: "Manage Receivable Payments",
      //   moduleName: "Finance-management",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   role: [""],
      //   privilege: ["Manage Receivable Payments"],
      //   submenu: [],
      // },
    ],
  },


  {
    path: "/erp-finance/finance-management/all-system-transactions",
    title: "Transactions",
    moduleName: "Transactions",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: [
      "All Transactions",
      "Manage Transaction",
      "All System Transactions",
      "View System Transactions",
      "Validate System Transactions",
      "Delete System Transactions",
    ],
    submenu: [
      // {
      //   path: "/erp-finance/finance-management/all-journals",
      //   title: "System Journals",
      //   moduleName: "Transactions",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   role: [""],
      //   privilege: ["All Transactions"],
      //   submenu: [],
      // },
      // {
      //   path: "/erp-finance/finance-management/all-system-transactions",
      //   title: "System Transactions",
      //   moduleName: "Transactions",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   role: [""],
      //   privilege: [
      //     "All Transactions",
      //     "Manage Transaction",
      //     "All System Transactions",
      //     "View System Transactions",
      //     "Validate System Transactions",
      //     "Delete System Transactions",
      //   ],
      //   submenu: [],
      // },
    ],
  },

  // {
  //   path: "/erp-finance/finance-management/system-reports",
  //   title: "Reports",
  //   moduleName: "dashboard",
  //   iconType: "feather",
  //   icon: "grid",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["All"],
  //   privilege: ["Dashboard"],
  //   submenu: [],
  // },

  {
    path: "/erp-finance/finance-management/core-synchronization",
    title: "Core Synchronization",
    moduleName: "synchronization",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },
];
export const FixedAssetsModule: RouteInfo[] = [
  {
    path: "",
    title: "MENUITEMS.MAIN.TEXT",
    moduleName: "",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },

  {
    path: "/erp-fixed-assets/dashboard",
    title: "Dashboard",
    moduleName: "dashboard",
    iconType: "feather",
    icon: "monitor",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },

  // Parameters
  {
    path: "",
    title: "PARAMETER SETTINGS",
    moduleName: "",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },

  {
    path: "",
    title: "Asset Categories",
    moduleName: "inventory-parameters",
    iconType: "feather",
    icon: "list",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["Dashboard"],
    submenu: [
      {
        path: "/erp-fixed-assets/fixed-assets-parameters/assets-categories",
        title: "All Categories",
        moduleName: "fixed-assets-parameters",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Dashboard"],
        submenu: [],
      },
      {
        path: "/erp-fixed-assets/fixed-assets-parameters/manage-assets-categories",
        title: "Manage Categories",
        moduleName: "fixed-assets-parameters",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Dashboard"],
        submenu: [],
      },
    ],
  },

  {
    path: "",
    title: "Asset Catalogue",
    moduleName: "fixed-assets-parameter",
    iconType: "feather",
    icon: "list",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["Dashboard"],
    submenu: [
      {
        path: "/erp-fixed-assets/fixed-assets-parameters/all-asset-catalogues",
        title: "Catalogue Items",
        moduleName: "fixed-assets-parameters",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Dashboard"],
        submenu: [],
      },
      {
        path: "/erp-fixed-assets/fixed-assets-parameters/manage-asset-catalogue",
        title: "Manage Catalogue",
        moduleName: "fixed-assets-parameters",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Dashboard"],
        submenu: [],
      },
    ],
  },

  // {
  //   path: "all-asset-catalogues",
  //   component: AllAssetCatalogueComponent,
  //   canActivate: [RoutePrivilegeGuard],
  //   data: { clientName: "FixedAssetsModule", requiredPrivilege: ["Dashboard"] },
  // },

  // {
  //   path: "manage-asset-catalogue",
  //   component: AssetCatalogueComponent,
  //   canActivate: [RoutePrivilegeGuard],
  //   data: { clientName: "FixedAssetsModule", requiredPrivilege: ["Dashboard"] },
  // },

  //Sub Modules
  {
    path: "",
    title: "Fixed Assets Sub-modules",
    moduleName: "",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    // privilege: ["All Fixed Assets", "Manage Fixed Assets"],
    submenu: [],
  },

  //**************************************************************************************************** */
  {
    path: "/erp-fixed-assets/fixed-assets-management/assets-received",
    title: "Received Assets",
    moduleName: "fixed-assets-management",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    // privilege: ["All Fixed Assets", "Manage Fixed Assets"],
    privilege: ["Dashboard"],
    submenu: [],
  },
  {
    path: "/erp-fixed-assets/fixed-assets-management/assets-record",
    title: "All Fixed Assets",
    moduleName: "fixed-assets-management",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    // privilege: ["All Fixed Assets", "Manage Fixed Assets"],
    privilege: ["Dashboard"],
    submenu: [],
  },

  {
    path: "/erp-fixed-assets/fixed-assets-management/assets-register",
    title: "Manage Fixed Assets",
    moduleName: "fixed-assets-management",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    // privilege: ["All Fixed Assets", "Manage Fixed Assets"],
    privilege: ["Dashboard"],
    submenu: [],
  },
  // {
  //   path: "/erp-fixed-assets/fixed-assets-management/add-asset",
  //   title: "Add Fixed Assets",
  //   moduleName: "fixed-assets-management",
  //   iconType: "feather",
  //   icon: "grid",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: [""],
  //   // privilege: ["All Fixed Assets", "Manage Fixed Assets"],
  //   privilege: ["Dashboard"],
  //   submenu: [

  //   ],
  // },
  // {
  //   path: "/erp-fixed-assets/fixed-assets-management/accounting",
  //   title: "Accounting",
  //   moduleName: "fixed-assets-management",
  //   iconType: "feather",
  //   icon: "grid",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: [""],
  //   // privilege: ["All Fixed Assets", "Manage Fixed Assets"],
  //   privilege: ["Dashboard"],
  //   submenu: [

  //   ],
  // },
  //Fixed assets management
  // {
  //   path: "",
  //   title: "Fixed Assets Management",
  //   moduleName: "fixed-assets-management",
  //   iconType: "feather",
  //   icon: "grid",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: [""],
  //   // privilege: ["All Fixed Assets", "Manage Fixed Assets"],
  //   privilege: ["Dashboard"],
  //   submenu: [
  //     {
  //       path: "/erp-fixed-assets/fixed-assets-management/assets-record",
  //       title: "All Fixed Assets",
  //       moduleName: "fixed-assets-management",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       // privilege: ["All Fixed Assets"],
  //       privilege: ["Dashboard"],
  //       submenu: [],
  //     },

  //     {
  //       path: "/erp-fixed-assets/fixed-assets-management/assets-register",
  //       title: "Manage Fixed Assets",
  //       moduleName: "fixed-assets-management",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       // privilege: ["Manage Fixed Assets"],
  //       privilege: ["Dashboard"],
  //       submenu: [],
  //     },

  //     {
  //       path: "/erp-fixed-assets/fixed-assets-management/add-asset",
  //       title: "Add Fixed Assets",
  //       moduleName: "fixed-assets-management",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       // privilege: ["Manage Fixed Assets"],
  //       privilege: ["Dashboard"],
  //       submenu: [],
  //     },

  //     {
  //       path: "/erp-fixed-assets/fixed-assets-management/accounting",
  //       title: "Accounting",
  //       moduleName: "fixed-assets-management",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       // privilege: ["Manage Fixed Assets"],
  //       privilege: ["Dashboard"],
  //       submenu: [],
  //     },
  //   ],
  // },
];
export const ImprestModule: RouteInfo[] = [
  {
    path: "",
    title: "MENUITEMS.MAIN.TEXT",
    moduleName: "",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },

  //Dashboard
  {
    path: "/erp-imprest/dashboard",
    title: "Dashboard",
    moduleName: "dashboard",
    iconType: "feather",
    icon: "monitor",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },

  //Sub Modules
  {
    path: "",
    title: "Imprest Sub-modules",
    moduleName: "",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All Imprest", "Manage Imprest"],
    submenu: [],
  },

  {
    path: "/erp-imprest/imprest-management/all-imprest",
    title: "My Imprests",
    moduleName: "Imprest-Management",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All Imprest", "Manage Imprest"],
    submenu: [],
  },

  {
    path: "/erp-imprest/imprest-management/manage-imprest",
    title: "Imprest Management",
    moduleName: "Imprest-Management",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All Imprest", "Manage Imprest"],
    submenu: [],
  },
  //imprest management
  // {
  //   path: "",
  //   title: "Imprest Management",
  //   moduleName: "imprest-management",
  //   iconType: "feather",
  //   icon: "grid",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: [""],
  //   privilege: ["All Imprest", "Manage Imprest"],
  //   submenu: [
  //     {
  //       path: "/erp-imprest/imprest-management/all-imprest",
  //       title: "All Imprest",
  //       moduleName: "imprest-management",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["All Imprest"],
  //       submenu: [],
  //     },
  //     {
  //       path: "/erp-imprest/imprest-management/manage-imprest",
  //       title: "Manage Imprest",
  //       moduleName: "imprest-management",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["Manage Imprest"],
  //       submenu: [],
  //     },
  //   ],
  // },
];
export const BudgetModule: RouteInfo[] = [
  //************************************************************************************************************************* */
  //BUDGET
  //************************************************************************************************************************* */
  {
    path: "",
    title: "MENUITEMS.MAIN.TEXT",
    moduleName: "",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },

  {
    path: "/erp-budget/dashboard",
    title: "Dashboard",
    moduleName: "dashboard",
    iconType: "feather",
    icon: "monitor",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },
  //Budget
  // {
  //   path: "",
  //   title: "Budget",
  //   moduleName: "budget",
  //   iconType: "feather",
  //   icon: "grid",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: [""],
  //   privilege: ["All Budgets", "Manage Budgets"],
  //   submenu: [
  //     {
  //       path: "/erp-budget/budget/all-budgets",
  //       title: "All Budgets",
  //       moduleName: "budgets",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["All Budgets"],
  //       submenu: [],
  //     },
  //     {
  //       path: "/erp-budget/budget/manage-budgets",
  //       title: "Manage Budgets",
  //       moduleName: "lease",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["Manage Budgets"],
  //       submenu: [],
  //     },
  //   ],
  // },

  {
    path: "",
    title: "Budget Sub-modules",
    moduleName: "",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All Budgets", "Manage Budgets"],
    submenu: [],
  },

  {
    path: "/erp-budget/budget/all-budgets",
    title: "All Budgets",
    moduleName: "Budget-Management",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All Budgets"],
    submenu: [],
  },

  {
    path: "/erp-budget/budget/manage-budgets",
    title: "Budget Management",
    moduleName: "Budget-Management",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Manage Budgets"],
    submenu: [],
  },

  {
    path: "/erp-budget/budget/budget-reports",
    title: "Budget Reports",
    moduleName: "dashboard",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },
];
export const SuppliersManagementModule: RouteInfo[] = [
  //Dashboard
  {
    path: "/erp-suppliers-management/dashboard",
    title: "Dashboard",
    moduleName: "dashboard",
    iconType: "feather",
    icon: "monitor",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },

  //Parameters
  {
    path: "",
    title: "PARAMETER SETTINGS",
    moduleName: "",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All Suppliers Categories", "Manage Supplier Category"],
    submenu: [],
  },

  // Supplier Categories
  {
    path: "",
    title: "Supplier Categories",
    moduleName: "supplier-categories",
    iconType: "feather",
    icon: "grid",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All Suppliers Categories", "Manage Supplier Category"],
    submenu: [
      {
        path: "/erp-suppliers-management/supplier-parameters/all-supplier-categories",
        title: "All Supplier Categories",
        moduleName: "supplier-categories",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All Suppliers Categories"],
        submenu: [],
      },
      {
        path: "/erp-suppliers-management/supplier-parameters/manage-supplier-category",
        title: "Manage Supplier Category",
        moduleName: "supplier-categories",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Manage Supplier Category"],
        submenu: [],
      },
    ],
  },

  //Sub modules
  {
    path: "",
    title: "Management Sub-modules",
    moduleName: "",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All Suppliers", "Manage Suppliers"],
    submenu: [],
  },

  //Suppliers management
  {
    path: "",
    title: "Suppliers Management",
    moduleName: "suppliers-maintenance",
    iconType: "feather",
    icon: "database",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All Suppliers", "Manage Suppliers"],
    submenu: [
      {
        path: "/erp-suppliers-management/suppliers-maintenance/all-suppliers",
        title: "All Suppliers",
        moduleName: "suppliers-maintenance",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All Suppliers"],
        submenu: [],
      },
      {
        path: "/erp-suppliers-management/suppliers-maintenance/manage-supplier",
        title: "Manage Supplier",
        moduleName: "suppliers-maintenance",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Manage Supplier"],
        submenu: [],
      },
    ],
  },

  //Supplier Profiles
  {
    path: "/erp-suppliers-management/supplier-profiles/all",
    title: "Company Profiles",
    moduleName: "supplier-profile-maintenance",
    iconType: "feather",
    icon: "database",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All Supplier Profiles", "Manage Supplier Profile"],
    submenu: [],
  },

  // Supplier Q&A Board
  // {
  //   path: "/erp-suppliers-management/faq-board",
  //   title: "Supplier Q&A Board",
  //   moduleName: "faq-admin",
  //   iconType: "material",
  //   icon: "forum",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["All"],
  //   privilege: ["Dashboard"],
  //   submenu: [],
  // },
];

export const PrepaymentModule: RouteInfo[] = [
  //************************************************************************************************************************* */
  //PREPAYMENTS MODULE
  //************************************************************************************************************************* */
  {
    path: "",
    title: "MENUITEMS.MAIN.TEXT",
    moduleName: "",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },

  {
    path: "/erp-prepayment/dashboard",
    title: "Dashboard",
    moduleName: "dashboard",
    iconType: "feather",
    icon: "monitor",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },

  {
    path: "",
    title: "Prepayments Management",
    moduleName: "",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All Prepayments", "Manage Prepayment"],
    submenu: [],
  },

  // {
  //   path: "",
  //   title: "Prepayments",
  //   moduleName: "prepayments",
  //   iconType: "feather",
  //   icon: "grid",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: [""],
  //   privilege: ["All Prepayments", "Manage Prepayment"],
  //   submenu: [
  //     {
  //       path: "/erp-prepayment/prepayments/all-prepayments",
  //       title: "All Prepayments",
  //       moduleName: "prepayments",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["All Prepayments"],
  //       submenu: [],
  //     },
  //     {
  //       path: "/erp-prepayment/prepayments/manage-prepayment",
  //       title: "Manage Prepayment",
  //       moduleName: "prepayments",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["Manage Prepayment"],
  //       submenu: [],
  //     },
  //   ],
  // },

  {
    path: "/erp-prepayment/prepayments/all-prepayments",
    title: "All Prepayments",
    moduleName: "prepayments",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All Prepayments", "Manage Prepayment"],
    submenu: [

    ],
  },
  {
    path: "/erp-prepayment/prepayments/manage-prepayment",
    title: "Manage Prepayment",
    moduleName: "prepayments",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All Prepayments", "Manage Prepayment"],
    submenu: [

    ],
  },
];

export const InventoryModule: RouteInfo[] = [
  //************************************************************************************************************************* */
  //PREPAYMENTS MODULE
  //************************************************************************************************************************* */
  {
    path: "",
    title: "MENUITEMS.MAIN.TEXT",
    moduleName: "",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },

  {
    path: "/erp-inventory/dashboard",
    title: "Dashboard",
    moduleName: "dashboard",
    iconType: "feather",
    icon: "monitor",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },

  {
    path: "",
    title: "PARAMETER SETTINGS",
    moduleName: "",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All Units", "Manage Units"],
    submenu: [],
  },

  //units of measure
  {
    path: "",
    title: "Units of Measure",
    moduleName: "inventory-paraeters",
    iconType: "feather",
    icon: "list",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All Units", "Manage Units"],
    submenu: [
      {
        path: "/erp-inventory/inventory-parameters/all-UnitOfMeasure",
        title: "All Units",
        moduleName: "inventory-paraeters",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All Units"],
        submenu: [],
      },
      {
        path: "/erp-inventory/inventory-parameters/manage-UnitOfMeasure",
        title: "Manage Units",
        moduleName: "inventory-paraeters",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Manage Units"],
        submenu: [],
      },
    ],
  },

  //item categories
  {
    path: "",
    title: "Item Categories",
    moduleName: "inventory-parameters",
    iconType: "feather",
    icon: "list",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All Item Categories", "Manage Item Categories"],
    submenu: [
      {
        path: "/erp-inventory/inventory-parameters/all-itemcat",
        title: "All categories",
        moduleName: "inventory-parameters",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All Item Categories"],
        submenu: [],
      },
      {
        path: "/erp-inventory/inventory-parameters/manage-itemcat",
        title: "Manage Category",
        moduleName: "inventory-parameters",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Manage Item Categories"],
        submenu: [],
      },
    ],
  },

  //master catalogue
  {
    path: "",
    title: "Master Catalogue",
    moduleName: "inventory-parmeters",
    iconType: "feather",
    icon: "list",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All Catalogue", "Manage Catalogue"],
    submenu: [
      {
        path: "/erp-inventory/inventory-parameters/all-catalogue",
        title: "All Catalogue",
        moduleName: "inventory-parmeters",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All Catalogue"],
        submenu: [],
      },
      {
        path: "/erp-inventory/inventory-parameters/manage-catalogue",
        title: "Manage Catalogue",
        moduleName: "inventory-parmeters",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Manage Catalogue"],
        submenu: [],
      },
    ],
  },

  //Main Store Management

  {
    path: "",
    title: "Main Store Management",
    moduleName: "inventory-params",
    iconType: "feather",
    icon: "list",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All Main Stores", "Manage Main Stores"],
    submenu: [
      {
        path: "/erp-inventory/inventory-parameters/all-mainstores",
        title: "All Main Stores",
        moduleName: "inventory-params",
        iconType: "",
        icon: "grid",
        class: "mat-menu-item",
        groupTitle: true,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All Main Stores"],
        submenu: [],
      },
      {
        path: "/erp-inventory/inventory-parameters/manage-mainstores",
        title: "Manage Main Stores",
        moduleName: "mainstores",
        iconType: "matArrowRightRound",
        icon: "",
        class: "matArrowRightRound",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Manage Main Stores"],
        submenu: [],
      },
    ],
  },

  //Branchstores
  // {
  //   path: "",
  //   title: "Branch Stores Management",
  //   moduleName: "inventory-parameter",
  //   iconType: "feather",
  //   icon: "list",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: [""],
  //   privilege: ["All Branch Stores", "Manage Branch Stores", ,],
  //   submenu: [
  //     {
  //       path: "/erp-inventory/inventory-parameters/all-branchstores",
  //       title: "All Branch Stores",
  //       moduleName: "inventory-parameter",
  //       iconType: "",
  //       icon: "grid",
  //       class: "mat-menu-item",
  //       groupTitle: true,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["All Branch Stores"],
  //       submenu: [],
  //     },
  //     {
  //       path: "/erp-inventory/inventory-parameters/manage-branchstores",
  //       title: "Manage Branch Stores",
  //       moduleName: "inventory-mangement",
  //       iconType: "",
  //       icon: "",
  //       class: "matArrowRightRound",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["Manage Branch Stores"],
  //       submenu: [],
  //     },
  //   ],
  // },

  //Branch Stores ROLS   Manage Branch ROLS
  // {
  //   path: "",
  //   title: "Branch Store ROLs",
  //   moduleName: "inventory-parmeter",
  //   iconType: "feather",
  //   icon: "list",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: [""],
  //   privilege: ["All Branch ROLS", "Manage Branch ROLS"],
  //   submenu: [
  //     {
  //       path: "/erp-inventory/inventory-parameters/all-rols",
  //       title: "All Branch ROLs",
  //       moduleName: "inventory-parameter",
  //       iconType: "",
  //       icon: "grid",
  //       class: "mat-menu-item",
  //       groupTitle: true,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["All Branch Stores"],
  //       submenu: [],
  //     },
  //     {
  //       path: "/erp-inventory/inventory-parameters/manage-rols",
  //       title: "Manage Branch ROLs",
  //       moduleName: "inventory-mangement",
  //       iconType: "",
  //       icon: "",
  //       class: "matArrowRightRound",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["Manage Branch Stores"],
  //       submenu: [],
  //     },
  //   ],
  // },

  {
    path: "",
    title: "Inventory Sub-Modules",
    moduleName: "",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All Catalogue", "Manage Catalogue"],
    submenu: [],
  },

  //Main Store Items Management
  {
    path: "",
    title: "Main Store Items",
    moduleName: "inventory-management",
    iconType: "feather",
    icon: "grid",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["All Stock", "Manage Stock"],
    submenu: [
      {
        path: "/erp-inventory/inventory/all-stock",
        title: "All Items",
        moduleName: "inventory-management",
        iconType: "",
        icon: "grid",
        class: "mat-menu-item",
        groupTitle: true,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["All Stock"],
        submenu: [],
      },
      {
        path: "/erp-inventory/inventory/manage-stock",
        title: "Manage Items",
        moduleName: "inventory-management",
        iconType: "matArrowRightRound",
        icon: "",
        class: "matArrowRightRound",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        privilege: ["Manage Stock"],
        submenu: [],
      },
    ],
  },

  //Branch Items Management
  // {
  //   path: "",
  //   title: "Branch Store Items",
  //   moduleName: "invenory-management",
  //   iconType: "feather",
  //   icon: "grid",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: [""],
  //   privilege: ["All Branch Stock", "Manage Branch Stock"],
  //   submenu: [
  //     {
  //       path: "/erp-inventory/inventory/all-branchItems",
  //       title: "All Branch Items",
  //       moduleName: "inventory-management",
  //       iconType: "",
  //       icon: "grid",
  //       class: "mat-menu-item",
  //       groupTitle: true,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["All Branch Stock"],
  //       submenu: [],
  //     },
  //     {
  //       path: "/erp-inventory/inventory/manage-branchItems",
  //       title: "Manage Branch Items",
  //       moduleName: "invenory-management",
  //       iconType: "matArrowRightRound",
  //       icon: "",
  //       class: "matArrowRightRound",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       privilege: ["Manage Branch Stock"],
  //       submenu: [],
  //     },
  //   ],
  // },

  //request items
  {
    path: "/erp-inventory/inventory/request-stock-directly",
    title: "Manage Store Requisition",
    moduleName: "inventory-managmnt",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["Request Stock Main", "Request Stock Branch"],
    submenu: [],
  },

  //view requisitions
  {
    path: "/erp-inventory/inventory/view-user-direct-requisition",
    title: "All Store Requisitions",
    moduleName: "inventoy-managmnt",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [""],
    privilege: ["View Branch Requisitions", "View User Requisitions"],
    submenu: [],
  },
];
